import { convertKnmOkvedsFormValueToKnmData } from 'KnmPackage/MainModule/common/convertKnmOkvedsFormValueToKnmData';
import { IKnmSubject248 } from 'APIPackage/KnmModule/interfaces/IKnmSubject248';

import { IKnmFormSubject } from '../interfaces/IKnmFormSubject';

export const convertSubjectFormValuesToKnmData = (
  values?: IKnmFormSubject,
  guid?: string | null,
): IKnmSubject248 | null => {
  if (!values) {
    return null;
  }

  const {
    inn,
    ogrn,
    okveds,
    organizationName,
    organizationAutocomplete: isAutocomplete,
    isFiz,
    mspCode,
    isSonko,
    subjectTypePm,
    subjectTypeKnm,
    country,
    document,
    kpp,
    rafpNza,
    workAddress,
    factualAddress,
    snils,
    smevRequestStatus,
    nkoForeignAgentsRegistryNumber,
    nkoForeignAgentsRegistryInclusionDate,
    nkoForeignAgentsRegistryExclusionDate,
    ervkId,
    firstOrganizationName,
    dateCreate,
    checkSubjectResult,
    itAccreditationResponse,
    isPresentInItRegistry,
    smevItAccreditationRequestStatus,
    position,
    inspectionResults,
    isFilledFromLink,
  } = values;

  const getAddressFields = () => {
    const isNotInFIAS = values[`locationnotInFIAS` as keyof typeof values] as boolean | undefined;
    const addressField = `locationAddress` as keyof typeof values;
    const address = values[addressField] as string | undefined;
    const region = values[`locationregion` as keyof typeof values] as
      | { id: number | string; label?: string }
      | undefined;
    const manualAddress = values[`locationmanualAddress` as keyof typeof values] as string | undefined;
    const fiasRegion = values[`locationfiasRegion` as keyof typeof values] as
      | { id: number | string; label?: string }
      | undefined;

    if (isNotInFIAS === true) {
      const regionId = region && 'id' in region && region.id != null ? String(region.id) : null;

      return {
        address: address || null,
        region: regionId,
        manualAddress: manualAddress || null,
        notInFIAS: true,
        fiasRegion: null,
      };
    }
    const fiasRegionId = fiasRegion && 'id' in fiasRegion && fiasRegion.id != null ? String(fiasRegion.id) : null;

    return {
      address: address || null,
      region: null,
      manualAddress: null,
      notInFIAS: isNotInFIAS === false ? false : null,
      fiasRegion: fiasRegionId,
      locationRegionCodeFromFns: values?.locationRegionCodeFromFns,
    };
  };

  const locationFields = getAddressFields();

  return {
    inn: inn || null,
    ogrn: ogrn || null,
    okveds: convertKnmOkvedsFormValueToKnmData(okveds),
    addressFns: null,
    organizationName: organizationName || null,
    mspCode: mspCode || null,
    checkSubjectResult: checkSubjectResult || null,
    dateCreate: dateCreate || null,
    firstOrganizationName: firstOrganizationName || null,
    guid: guid || null,
    act: null,
    isFiz: typeof isFiz === 'boolean' ? isFiz : null,
    resultDecisions: null,
    isAutocomplete: typeof isAutocomplete === 'boolean' ? isAutocomplete : null,
    isDocumentOrganization: null,
    nkoForeignAgentsRegistryNumber: nkoForeignAgentsRegistryNumber || null,
    nkoForeignAgentsRegistryInclusionDate: nkoForeignAgentsRegistryInclusionDate || null,
    nkoForeignAgentsRegistryExclusionDate: nkoForeignAgentsRegistryExclusionDate || null,
    isNko: !!nkoForeignAgentsRegistryInclusionDate,
    subjectType: subjectTypePm || subjectTypeKnm || null,
    kpp: kpp || null,
    smevRequestStatus: smevRequestStatus || null,
    rafpNza: rafpNza || null,
    isForeignSubjectAgencyNotRegistredInRf: null,
    country: country || null,
    isSonko: typeof isSonko === 'boolean' ? isSonko : null,
    locationAddress: locationFields.address,
    workAddress: workAddress || null,
    factualAddress: factualAddress || null,
    snils: snils || null,
    document: document || null,
    epguNotifications: null,
    ervkId: ervkId || null,
    isPresentInItRegistry: isPresentInItRegistry ?? null,
    itAccreditationResponse: itAccreditationResponse ?? null,
    smevItAccreditationRequestStatus: smevItAccreditationRequestStatus ?? null,
    position: position ?? null,
    inspectionResults,
    isFilledFromLink: isFilledFromLink || null,
    locationRegion: locationFields.region,
    locationNotInFIAS: typeof locationFields.notInFIAS === 'boolean' ? locationFields.notInFIAS : null,
    locationManualAddress: locationFields.manualAddress,
    locationFiasRegion: locationFields.fiasRegion,
    locationRegionCodeFromFns: locationFields.locationRegionCodeFromFns || null,
  };
};
